import React, { useState, useEffect, useMemo } from 'react';
import { FormGroup, Input, Label, Button, Col, Row } from 'reactstrap';
import './PortActivation.css';
import { connect } from 'react-redux';
import CompanyAutocomplete from './CompanyAutocomplete';
import LocationDetails from './LocationDetails';
import OptionalDropdownSelect from './OptionalDropdownSelect';
import { getGroupsFilterCompanies } from '../actions/Reports';
import SpinnerCircles from './Spinner/SpinerCircles';

const lineTypeList = [
  { name: 'Alarm', value: 'alarm' },
  { name: 'Fire Alarm', value: 'fireAlarm' },
  { name: 'Secure Entry', value: 'secureEntry' },
  { name: 'Elevator', value: 'elevator' },
  { name: 'Fax', value: 'fax' },
  { name: 'Modem', value: 'modem' },
  { name: 'Voice', value: 'voice' },
  { name: 'Hunt', value: 'hunt' },
  { name: 'OOBM', value: 'oob' },
  { name: 'Page', value: 'page' },
  { name: 'PRI', value: 'pri' },
  { name: 'Ring Down', value: 'ringDown' },
];
const PortActivationBody = ({
  companies,
  locations,
  selectedCompany,
  selectedDates,
  selectAlarmProtocol,
  alarmProtocolValue,
  disabledButton,
  locationId,
  summaryStatus,
  downloadType,
  selectedReport,
  includeSummary,
  alarmProtocol,
  user,
  companyGroups,
  getGroupsFilterCompanies,
  companyGroupFilteredList,
  reportSymbol,
  selectedLineTypes,
  setUptimeOpt,
  setIntegrationValue,
  boxes,
  selectedBox,
  boxNumbers,
  selectedNumber,
  boxesLoading,
  selectedCompanies
}) => {
  const [locationStatus, setLocationStatus] = useState(false);
  const [companiesList, setCompaniesList] = useState(companies.docs || []);
  const [summary, setSummary] = useState(false);
  const [type, setType] = useState(false);
  const [dateRange, setDateRange] = useState({
    fromDate: '',
    toDate: '',
  });
  const [clearList, setClearList] = useState(false);
  const [uptime, setUptime] = useState({
    option: 'all',
    value: '',
    time: 'weeks'
  });

  useEffect(() => {
    setCompaniesList(companies.docs || []);
  }, [companies]);

  useEffect(() => {
    setUptimeOpt(uptime);
  }, [uptime]);
  
  const [integration, setIntegration] = useState("all");

  useEffect(() => {
    setIntegrationValue(integration);
  }, [integration]);

  useEffect(() => {
    if (selectedReport) {
      if (dateRange.fromDate.length > 0 && dateRange.toDate.length > 0 && type) {
        disabledButton(false);
      }
      if (reportSymbol === 'BOL' && type && dateRange.fromDate.length > 0) { // Date range is optional for Unregistered Edge Devices
        disabledButton(false);
      }
    } else {
      type ? disabledButton(false) : locationStatus && disabledButton(false);
    }
    selectedDates(dateRange);
    if (alarmProtocol) {
      if (!alarmProtocolValue.length) {
        disabledButton(true);
      } else {
        disabledButton(false);
      }
    }
  }, [locationStatus, dateRange, type, alarmProtocolValue]);
  const handleSelectedCompanies = list => {
    selectedCompany(list);
  };
  const onDateChange = e => {
    setDateRange({ ...dateRange, [e.currentTarget.name]: e.currentTarget.value });
  };
  const onSummaryChange = value => {
    if (summary) {
      summaryStatus('no');
    } else {
      summaryStatus('yes');
    }
    setSummary(!summary);
  };
  const onLineTypeSelect = e => {
    const lineType = e.map(item => item.value);
    selectedLineTypes(lineType);
  };
  useEffect(() => {
    if (reportSymbol === 'LT') {
      const allLineTypes = lineTypeList.map(item => item.value);
      selectedLineTypes(allLineTypes);
    }
  }, []);

  const companyPlaceholder = () => {
    const isCompanyListEmpty = companiesList?.length === 0;
    const isAdminOrEnterpriseAdmin = user.role === 'admin' || user.role === 'enterpriseAdmin';
    const isSuperAdmin = user.role === 'superAdmin';
    return isCompanyListEmpty
      ? isAdminOrEnterpriseAdmin
        ? user.company.name
        : 'No Company Found'
      : isSuperAdmin
      ? 'All Companies'
      : 'Select Company';
  }

  return (
    <>
      <Row style={{ display: 'flex', flexDirection: 'row' }}>
        <Col md={6}>
          <>
            <h1>Company</h1>
            <>
              <OptionalDropdownSelect
                isDisabled={!(companiesList.length > 0)}
                MultiSelect={reportSymbol !== 'PORT_CDR'}
                nameTag="company"
                filterTag="name"
                className="reporting-company-filter"
                placeholder={companyPlaceholder()}
                dropdownList={companiesList}
                onChange={handleSelectedCompanies}
                clearList={clearList}
              />
            </>
            {reportSymbol === 'PORT_CDR' && (
              <>
                <h1>Select Edge Device</h1>
                {boxesLoading ? (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <SpinnerCircles />
                    <span>Loading edge devices...</span>
                  </div>
                ) : selectedCompanies && selectedCompanies.length > 0 ? (
                  boxes && boxes.length > 0 ? (
                    <OptionalDropdownSelect
                      nameTag="boxName"
                      filterTag="displayName"
                      className="testing-filter"
                      placeholder="Select Box"
                      dropdownList={boxes.map(box => ({
                        ...box,
                        displayName: `${box.serialNumber} - ${box.displayName}`
                      }))}
                      onChange={selectedBox}
                    />
                  ) : (
                    <div style={{ color: 'gray', fontStyle: 'italic' }}>
                      No edge devices found for the selected company
                    </div>
                  )
                ) : (
                  <div style={{ color: 'gray', fontStyle: 'italic' }}>
                    Please select a company first
                  </div>
                )}
              </>
            )}
            {reportSymbol === 'PORT_CDR' && boxNumbers && boxNumbers.length > 0 && (
              <>
                <h1>Select Port Number</h1>
                <OptionalDropdownSelect
                  nameTag="number"
                  filterTag="displayName"
                  className="testing-filter"
                  placeholder="Select Number"
                  dropdownList={boxNumbers.map(num => ({
                    ...num,
                    displayName: `${num.portNumber} - ${num.number}`
                  }))}
                  onChange={selectedNumber}
                />
              </>
            )}
            {reportSymbol === 'LT' && (
              <>
                <h1>Line Type</h1>
                <OptionalDropdownSelect
                  MultiSelect
                  nameTag="name"
                  filterTag="name"
                  className="testing-filter"
                  placeholder="Select Line Type"
                  dropdownList={lineTypeList}
                  showFirstListElement
                  onChange={onLineTypeSelect}
                />
              </>
            )}
          </>
        </Col>
        <Col md={6}>
          <div>
            {!alarmProtocol && selectedReport && (
              <>
                <h1>
                  {reportSymbol === 'BOL' ? "Search devices Offline as of…" : "Date Range"}
                </h1>
                <Row>
                  
                  <Col md={5}>
                    <Input
                      placeholder="Please specify"
                      required
                      type="date"
                      name="fromDate"
                      value={dateRange.fromDate}
                      onChange={onDateChange}
                    />
                  </Col>
                 
                  <Col md={1}>
                    {reportSymbol !== 'BOL' && <p style={{ marginTop: '5px' }}>To</p>}
                  </Col>
                  {reportSymbol !== 'BOL' && (
                    <Col md={5}>
                      <Input
                        placeholder="Please specify"
                        required
                        type="date"
                        name="toDate"
                        value={dateRange.toDate}
                        onChange={onDateChange}
                      />
                    </Col>
                  )}
                </Row>
              </>
            )}

            {alarmProtocol && (
              <>
                <h1>Alarm Protocol Relay Enabled</h1>
                <Input
                  type="select"
                  className="testing-filter"
                  name="aprReporting"
                  value={alarmProtocolValue}
                  onChange={e => {
                    selectAlarmProtocol(e?.currentTarget.value);
                  }}
                >
                  {!alarmProtocolValue.length && <option value="">Select value</option>}
                  <option key="True" value="true">
                    True
                  </option>
                  <option key="False" value="false">
                    False
                  </option>
                </Input>
              </>
            )}

            {reportSymbol === 'UTR' && (
              <div className='uptime-report'>
                <h1>Select Uptime</h1>
                <Row>
                  <Col sm={4}>
                    <select
                      className="form-control"
                      name="select-chart"
                      value={uptime?.option}
                      onChange={(e) => {
                        if (e.target.value === 'all') {
                          setUptime({ ...uptime, option: e.target.value, value: '', time: 'weeks' });
                          return;
                        }
                        setUptime({ ...uptime, option: e.target.value });
                      }}
                    >
                      {['All', 'Greater Than', 'Less Than'].map(item => (
                        <option key={item?.replace(/\s+/g, '-').toLowerCase()} className="chart-options" id={`test-${item?.replace(/\s+/g, '-').toLowerCase()}`} value={item?.toLowerCase()}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </Col>
                  {uptime?.option !== 'all' && (
                    <>
                      <Col sm={4}>
                        <Input
                          type="text"
                          name="uptime"
                          placeholder="Enter Uptime"
                          defaultValue={uptime?.value}
                          onChange={(e) => {
                            setUptime({ ...uptime, value: e.target.value });
                          }}
                        />
                      </Col>
                      <Col sm={4}>
                        <select
                          className="form-control"
                          name="select-chart"
                          value={uptime?.time}
                          onChange={(e) => {
                            setUptime({ ...uptime, time: e.target.value });
                          }}
                        >
                          {['Weeks', 'Days', 'Hours', 'Minutes'].map(item => (
                            <option key={item?.replace(/\s+/g, '-').toLowerCase()} className="chart-options" id={`test-${item?.replace(/\s+/g, '-').toLowerCase()}`} value={item?.toLowerCase()}>
                              {item}
                            </option>
                          ))}
                        </select>
                      </Col>
                    </>
                  )}
                </Row>
              </div>
            )}
            {reportSymbol === 'EDI' && (
              <div className='integration-report'>
                <h1>Select Integration Type</h1>
                <Row>
                  <Col sm={4}>
                    <select
                      className="form-control"
                      name="select-chart"
                      value={integration}
                      onChange={(e) => { setIntegration(e.target.value) }}
                    >
                      {['All', 'Integrated', 'Not Integrated'].map(item => (
                        <option key={item?.replace(/\s+/g, '-').toLowerCase()} className="chart-options" id={`test-${item?.replace(/\s+/g, '-').toLowerCase()}`} value={item?.toLowerCase()}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </Col>
                </Row>
              </div>
            )}
            <h1>Export Format</h1>
            <Row>
              <Col sm={3}>
                <Label check sm={6}>
                  <Input
                    type="radio"
                    name="exportType"
                    onChange={() => {
                      downloadType('csv');
                      setType(true);
                    }}
                  />
                  CSV
                </Label>
              </Col>
              <Col sm={3}>
                <Label check sm={6}>
                  <Input
                    type="radio"
                    name="exportType"
                    onChange={() => {
                      downloadType('pdf');
                      setType(true);
                    }}
                  />
                  PDF
                </Label>
              </Col>
            </Row>
            {includeSummary && (
              <FormGroup
                style={{
                  marginRight: '20px',
                  marginTop: '20px',
                  display: 'flex',
                  alignItems: 'flex-end',
                }}
              >
                <Label check>
                  <Input type="checkbox" checked={summary} onChange={onSummaryChange} />
                  Include Summary Report
                </Label>
              </FormGroup>
            )}
          </div>
        </Col>
      </Row>
    </>
  );
};
const mapStateToProps = state => {
  return {
    user: state.AppState.user,
    boxes: state.AppState.boxes,
    companies: state.AppState.companies,
    companyGroupFilteredList: state.AppState.groupFilteredCompanies,
  };
};
const mapDispatchToProps = dispatch => ({
  getGroupsFilterCompanies: (token, gid) => dispatch(getGroupsFilterCompanies(token, gid)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PortActivationBody);
